<template>
    <!-- BaseDialog.vue -->
    <v-dialog
        :max-width="dialogMaxWidth"
        :persistent="persistent"
        :retain-focus="false"
        :value="value"
        @click="handleClick"
        @click:outside="handleClickOutside"
    >
        <!-- @slot default -->
        <slot></slot>
    </v-dialog>
</template>

<script>
    // Mixins
    import BaseDialogMixin from '@windsor-telecom-management/client-core/src/mixins/core/base-dialog.mixin'

    export default {
        name: 'BaseDialog',
        mixins: [BaseDialogMixin],
        props: {
            /**
             * Set the dialog as persistent.  Cannot be dismissed by clicking overlay.
             */
            persistent: {
                type: Boolean,
                default: true
            },
            /**
             * Toggle the visibility of the dialog
             */
            value: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleClick () {
                /**
                 * @event click
                 */
                this.$emit('click')
            },
            handleClickOutside () {
                /**
                 * @event click:outside
                 */
                this.$emit('click:outside')
            }
        }
    }
</script>
